import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Input, InputOdontograma } from "../../components/Form";
// import TwoColumRow from "../../components/TwoColumRow";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {

  getEstudiosByCitaId,

} from "../../redux/features/estudiosSlice";
import toast from "react-hot-toast";
import { FaTimes } from "react-icons/fa";
import { FileIcon } from "../../components/FileIcon";
import { Switch } from "@headlessui/react";
import {
  agruparLaboratorios,


  deleteAgrupacionLaboratorios,
  deleteGrupoLaboratorio,
  getGruposLaboratorios,
} from "../../redux/features/gruposLaboratoriosSlice";
import { getLaboratorios } from "../../redux/features/laboratorios2Slice";
import { RiDeleteBinLine, RiXingLine } from "react-icons/ri";
import ConfirmationAlert from "../../components/ConfirmationAlert";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { apiUrl } from "../../redux/apiUrl";
import { LAB_TIMEOUT } from "../../utils/laboratoryNetwork";

//estos dos objetos fueron creados para la primera version
//en esta nueva no se los usa, pero se los dejo por si vuelven a ser requeridos
const laboratorioLabels = [
  "Coprocultivo",
  "Tinción de Gram",
  "Urocultivo y antibíograma",
  "Hemocultivo y antibíograma",
  "Cultivo de secreción vaginal",
  "Cultivo de secrecion uretral",
  "Cultivo de secrecion bronquial",
  "Cultivo de secrecion purulenta",
  "Cultivo micologico",
  "Hemoglobina - Hematocrito",
  "Urea",
  "Creatinina",
  "Glucosa",
  "Colesterol Total",
  "LDH",
  "Acido Úrico",
  "Hemoglobina Glicosilada",
  "Eritrosedimentacion",
  "Grupo Sanguíneo y factor RH",
  "T. de Protombina(TP)",
  "T. Tromboplastina P. Activada (TTPA)",
  "Recuento de Plaquetas",
  "Orina Completa",
  "Proteinuria en Orina",
  "Glucosa Post Prandial",
  "Curva de Tolerancia a la Glucosa",
  "HDL Colesterol",
  "LDL Colesterol",
  "Triglicéridos",
  "Bilirrubinas",
  "GOT - Transaminasa",
  "GPT - Transanaminasa",
  "Fosfatasa Alcalina",
  "GGT",
  "Amilasa",
  "Proteinas Totales",
  "Albuminas",
  "Calcio Ionico",
  "Fósforo",
  "Magnesio",
  "Sodio",
  "Potasio",
  "Troponina I",
  "Hierro Sérico",
  "Ferritina",
  "Transferrina",
  "% de Saturación",
  "Vitamina B12",
  "Vitamina D25",
  "PCR",
  "Chagas IFI Ig G. lg M",
  "Chagas HAI",
  "PSA",
  "T3",
  "TSH",
  "T4 Libre",
  "Hemograma Completo",
  "FSH",
  "LH",
  "DHEA-S",
];
const laboratorioKeys = [
  "coprocultivo",
  "tincion_de_gram",
  "urocultivo_y_antibiograma",
  "hemocultivo_y_antibiograma",
  "cultivo_de_secrecion_vaginal",
  "cultivo_de_secrecion_uretral",
  "cultivo_de_secrecion_bronquial",
  "cultivo_de_secrecion_purulenta",
  "cultivo_micologico",
  "hemoglobina_hematocrito",
  "urea",
  "creatinina",
  "glucosa",
  "colesterol_total",
  "ldh",
  "acido_urico",
  "hemoglobina_glicosilada",
  "eritrosedimentacion",
  "grupo_sanguineo_y_factor_rh",
  "t_de_protombina_tp",
  "t_tromboplastina_p_activada_ttpa",
  "recuento_de_plaquetas",
  "orina_completa",
  "proteinuria_en_orina",
  "glucosa_post_prandial",
  "curva_de_tolerancia_a_la_glucosa",
  "hdl_colesterol",
  "ldl_colesterol",
  "trigliceridos",
  "bilirrubinas",
  "got_transaminasa",
  "gpt_transaminasa",
  "fosfatasa_alcalina",
  "ggt",
  "amilasa",
  "proteinas_totales",
  "albuminas",
  "calcio_ionico",
  "fosforo",
  "magnesio",
  "sodio",
  "potasio",
  "troponina_i",
  "hierro_serico",
  "ferritina",
  "transferrina",
  "porcentaje_de_saturacion",
  "vitamina_b12",
  "vitamina_d25",
  "pcr",
  "chagas_ifi_ig_g_lg_m",
  "chagas_hai",
  "psa",
  "t3",
  "tsh",
  "t4_libre",
  "hemograma_completo",
  "hormona_foliculoestimulante",
  "hormona_luteinizante",
  "dhea_s",
];

const Laboratorio = ({ data, onClose }) => {
  //extrae todos los grupos registrados
  const {
    data: gruposLaboratorios,
    isLoading: loadingGrupoLAboratorios,
    error: errorGrupoLAboratorios,
  } = useSelector((state) => state.gruposLaboratorios);
  const dispatch = useDispatch();

  //extrae todos los laboratorios registrados
  const {
    data: laboratorios,
    isLoading: loadingLaboratorios,
    error: errorLaboratorios,
  } = useSelector((state) => state.laboratorios2);

  //extrae todas las relaciones entre laboratios grupos
  const {
    agrupaciones,
    isLoading: loadingAgrupaciones,
    error: errorAgrupaciones,
  } = useSelector((state) => state.gruposLaboratorios);

  const [archivos, setArchivos] = useState(null);
  const [files, setFiles] = useState([]);
  const [cargando, setCargando] = useState(false);
  const saving = useRef(false);
  const pendingSubmission = useRef(null);
  const [saveUncertain, setSaveUncertain] = useState(false);
  const [loadState, setLoadState] = useState("loading");
  const [online, setOnline] = useState(navigator.onLine);
  const initialized = useRef(null);
  const loadGeneration = useRef(0);
  const [labsAGuardar, setLabsAGuardar] = useState([]);
  const [modificar, setModificar] = useState(false);
  const { register, handleSubmit, setValue } = useForm();

  const [values, setValues] = useState(
    // laboratorioKeys.reduce((acc, key) => {
    //   acc[key] = false;
    //   return acc;
    // }, {})
    {}
  );

  // const [inputValues, setInputValues] = useState(
  //   laboratorioKeys.reduce((acc, key) => {
  //     acc[key] = "";
  //     return acc;
  //   }, {})
  // );

  const [valueSearch, setValueSearch] = useState("");
  const [filtered, setFiltered] = useState([]);

  const handleSearch = (e) => {
    setValueSearch(e.target.value);
    setFiltered(
      laboratorioLabels.filter((value) =>
        value.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  // Initialize from the order itself, even if the catalog has not arrived yet.
  // A catalog refresh must never overwrite edits already typed by the doctor.
  useEffect(() => {
    const key = JSON.stringify([data?.patient_id, data?.cita_id, data?.orden_lab]);
    if (initialized.current === key) return;
    initialized.current = key;
    pendingSubmission.current = null;
    setSaveUncertain(false);
    const results = data?.resultados || [];
    setModificar(results.length > 0);
    setValues(Object.fromEntries(results.map((r) => [`lab_${r.laboratorios_id}`, true])));
    setValue("resultados", Object.fromEntries(results.map((r) => [`lab_${r.laboratorios_id}`, r.resultado ?? ""])));
  }, [data, setValue]);

  //nose que hace exactamente pero que se quede ahi
  useEffect(() => {
    const formattedData = Object.keys(data).reduce((acc, key) => {
      const normalizedKey = key
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/[().,-]/g, "");
      acc[normalizedKey] = data[key];
      return acc;
    }, {});
    setArchivos(data.archivos);
  }, [data, setValue]);

  const loadCatalog = useCallback(async () => {
    const generation = ++loadGeneration.current;
    setLoadState("loading");
    const results = await Promise.allSettled([
      dispatch(getLaboratorios()).unwrap(),
      dispatch(getGruposLaboratorios()).unwrap(),
      dispatch(agruparLaboratorios()).unwrap(),
    ]);
    if (generation === loadGeneration.current) {
      setLoadState(results.some((r) => r.status === "rejected") ? "error" : "ready");
    }
  }, [dispatch]);

  useEffect(() => {
    loadCatalog();
    const reconnect = () => { setOnline(true); loadCatalog(); };
    const disconnect = () => setOnline(false);
    window.addEventListener("online", reconnect);
    window.addEventListener("offline", disconnect);
    return () => {
      loadGeneration.current += 1;
      window.removeEventListener("online", reconnect);
      window.removeEventListener("offline", disconnect);
    };
  }, [loadCatalog]);

  const [listaFinal, setListaFinal] = useState([]);

  //crea el objeto para el listado de los switchs
  useEffect(() => {
    if (!agrupaciones || !laboratorios) return;

    //añade al objeto laboratorios el tipo: laboratorio y el grupoIds que es un array que  puede ser vacio o tener multiples valores
    //grupoIds hace referencia a los grupos los cuales pertenece el laboratorio en cuestion
    const laboratoriosModificados = laboratorios.map((lab) => {
      const gruposVinculados = agrupaciones
        .filter((agrup) => agrup.laboratorio?.id === lab.id)
        .map((agrup) => agrup.grupo_laboratorio?.id);

      return {
        ...lab,
        tipo: "laboratorio",
        grupoIds: gruposVinculados, // Será un array vacío si no hay referencias
      };
    });

    //construyeel objeto final resultado final
    //añade al objeto gruposlaboratorios el tipo: grupo
    const resultadoFinal = [
      ...gruposLaboratorios.map((g) => ({ ...g, tipo: "grupo" })),
      ...laboratoriosModificados,
    ];

    setListaFinal(resultadoFinal);
    // console.log("Lista completa:", resultadoFinal);
  }, [agrupaciones, laboratorios, gruposLaboratorios]);

  //donde se trabaja con los estados de los switches
  const handleSwitchChange = (item) => (checked) => {
    if (item.tipo === "grupo") {
      const labsDelGrupo = listaFinal.filter(
        (lab) =>
          lab.tipo === "laboratorio" &&
          Array.isArray(lab.grupoIds) &&
          lab.grupoIds.includes(item.id)
      );
      setValues((prev) => {
        const newValues = { ...prev };
        labsDelGrupo.forEach((lab) => {
          const key = `lab_${lab.id}`;
          newValues[key] = checked;
        });
        newValues[`grupo_${item.id}`] = checked;
        const todosGrupos = listaFinal.filter((grup) => grup.tipo === "grupo");
        todosGrupos.forEach((grupo) => {
          const labsDelGrupoAux = listaFinal.filter(
            (lab) =>
              lab.tipo === "laboratorio" &&
              Array.isArray(lab.grupoIds) &&
              lab.grupoIds.includes(grupo.id)
          );
          const todosMarcados = labsDelGrupoAux.every((lab) => {
            const key = `lab_${lab.id}`;
            return newValues[key];
          });
          newValues[`grupo_${grupo.id}`] = todosMarcados;
        });
        return newValues;
      });
    } else {
      setValues((prev) => {
        const key = `lab_${item.id}`;
        const newValues = { ...prev, [key]: checked };
        if (Array.isArray(item.grupoIds)) {
          item.grupoIds.forEach((grupoId) => {
            const labsDelGrupo = listaFinal.filter(
              (lab) =>
                lab.tipo === "laboratorio" &&
                Array.isArray(lab.grupoIds) &&
                lab.grupoIds.includes(grupoId)
            );
            const todosMarcados = labsDelGrupo.every((lab) => {
              const labkey = `lab_${lab.id}`;
              return newValues[labkey];
            });
            newValues[`grupo_${grupoId}`] = todosMarcados;
            if (!checked && !todosMarcados) {
              newValues[`grupo_${grupoId}`] = false;
            }
          });
        }
        return newValues;
      });
    }
  };

  const onSubmit = async (body) => {
    if (saving.current) return;
    if (navigator.onLine === false) {
      toast.error("Sin conexión. Lo escrito sigue en este formulario; guarde cuando vuelva internet.");
      return;
    }
    if (!pendingSubmission.current) {
      if (loadState !== "ready") return;
      const selectedLabs = Object.keys(values).filter((key) => key.startsWith("lab_") && values[key]);
      if (!selectedLabs.length) {
        toast.error("Debe seleccionar al menos un laboratorio");
        return;
      }
      pendingSubmission.current = {
        submission_id: uuidv4(),
        cita_id: data.cita_id,
        orden_lab: modificar ? data.orden_lab : null,
        resultados: selectedLabs.map((key) => ({
          laboratorios_id: Number(key.replace("lab_", "")),
          resultado: body.resultados?.[key] || "",
        })),
      };
    }
    saving.current = true;
    setCargando(true);
    try {
      await axios.post(`${apiUrl}/api/v1/resultado/orden`, pendingSubmission.current, { timeout: LAB_TIMEOUT });
    } catch (error) {
      // Preserve the exact ID and payload if the server may have committed the order.
      const uncertain = !error.response || error.response.status >= 500 || error.response.status === 408;
      setSaveUncertain(uncertain);
      if (!uncertain) pendingSubmission.current = null;
      toast.error(uncertain
        ? "No se pudo confirmar el guardado. Reintente confirmar sin cerrar esta ventana; no se duplicará la orden."
        : error.response?.data?.message || "No se pudo guardar la orden. Revise los datos e intente otra vez.");
      saving.current = false;
      setCargando(false);
      return;
    }
    pendingSubmission.current = null;
    setSaveUncertain(false);
    toast.success("Orden guardada con éxito!");
    try {
      await dispatch(getEstudiosByCitaId(data.patient_id)).unwrap();
    } catch {
      toast.error("La orden está guardada, pero no se pudo actualizar la lista. Vuelva a abrir los laboratorios para verla.");
    }
    saving.current = false;
    setCargando(false);
    onClose();
  };

  //codgio para cuando se trabaje con archivos
  //para eliminar un archivo
  const deleteFile = (index) => {
    setFiles(files.filter((file, i) => index !== i));
  };

  //eliminar un grupo de laboratorio
  const eliminarGrupoLaboratorio = async (id) => {
    ConfirmationAlert({
      title: "Eliminar Grupo de Laboratorio",
      text: "¿Está seguro que desea eliminar este Grupo de Laboratorio? Esta acción no se puede deshacer.",
      onAccept: async () => {
        try {
          await dispatch(deleteAgrupacionLaboratorios(id)).unwrap();
          await dispatch(deleteGrupoLaboratorio(id)).unwrap();
          dispatch(agruparLaboratorios());
          dispatch(getGruposLaboratorios());
          toast.success("Agrupacion eliminada con exito");
        } catch (error) {
          console.error("Error al eliminar documento:", error);
          toast.error(
            `Error al eliminar el documento: ${
              error.message || JSON.stringify(error)
            }`
          );
        }
      },
    });
  };

  return (
    <>
      {!online && <p role="status" className="mb-3 text-sm">Sin conexión. Lo escrito se conserva mientras mantenga este formulario abierto. Todavía no está guardado en el servidor.</p>}
      {loadState === "loading" && <p role="status" className="mb-3 text-sm">Cargando laboratorios… Una conexión lenta puede tardar unos minutos.</p>}
      {loadState === "error" && <div role="alert" className="mb-3 text-sm">No se pudieron cargar todos los laboratorios. Lo escrito se conserva. <button type="button" onClick={loadCatalog}>Reintentar carga</button></div>}
      {saveUncertain && <p role="alert" className="mb-3 text-sm">Guardado pendiente de confirmar. Pulse «Confirmar guardado» para comprobar la misma solicitud sin duplicarla. No cierre esta ventana.</p>}
      <fieldset disabled={cargando || saveUncertain || loadState !== "ready"}>
      <div className="h-96 border px-5 mb-5 pb-5 rounded-lg grid md:grid-cols-2 gap-4">
        <div className="overflow-y-scroll md:pr-2 md:border-r border-b md:border-b-0 pb-2 md:pb-0">
          <div className="mt-2 flex gap-2">
            <div className="w-full">
              <InputOdontograma
                name={"buscador_analisis"}
                label={"Buscar"}
                color={true}
                register={register("pieza", {
                  onChange: (e) => handleSearch(e),
                })}
                disabled={false}
                placeholder={"Laboratorios"}
              />
            </div>
            {/* {(!Array.isArray(data.resultados) || data.resultados.length === 0) && (<></>)} */}
            {/* <div className="w-1/2 mt-8">
              <Button
                label="Nuevo Grupo"
                onClick={() => setOpenModalRegistroGrupo(true)}
              />
            </div> */}
          </div>
          {valueSearch
            ? listaFinal
                .filter(
                  (item) =>
                    item.nombre
                      .toLowerCase()
                      .includes(valueSearch.toLowerCase()) &&
                    item.grupoNombre !== "sin agrupar"
                )
                .map((item, index) => (
                  <div key={index} className="flex items-start py-2">
                    {" "}
                    {/* Cambio 1: items-start y py-2 */}
                    <div className="flex-shrink-0 h-10 flex items-center">
                      {" "}
                      {/* Cambio 2: Contenedor para el switch */}
                      <Switch
                        checked={
                          !!values[
                            item.tipo === "grupo"
                              ? `grupo_${item.id}`
                              : `lab_${item.id}`
                          ]
                        }
                        onChange={handleSwitchChange(item)}
                        className={`${
                          values[
                            item.tipo === "grupo"
                              ? `grupo_${item.id}`
                              : `lab_${item.id}`
                          ]
                            ? "bg-subMain"
                            : "bg-border"
                        } 
                    relative inline-flex p-[2px] w-12 cursor-pointer rounded-full transitions flex-shrink-0`}
                      >
                        <span
                          aria-hidden="true"
                          className={`${
                            values[
                              item.tipo === "grupo"
                                ? `grupo_${item.id}`
                                : `lab_${item.id}`
                            ]
                              ? "translate-x-5"
                              : "translate-x-0"
                          } 
                      pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg transitions`}
                        />
                      </Switch>
                    </div>
                    {/* Contenedor principal del contenido */}
                    <div
                      className={`flex ${
                        item.tipo === "laboratorio" && values[item.nombre]
                          ? "w-full"
                          : ""
                      } ml-3`}
                    >
                      {/* Label y tag - ancho condicional */}
                      <div
                        className={`${
                          item.tipo === "laboratorio" && values[item.nombre]
                            ? "w-1/2 pr-2"
                            : "w-full"
                        } flex flex-col`}
                      >
                        {/* Label - ocupa el espacio necesario */}
                        <span className="capitalize text-sm">
                          {item.nombre}
                        </span>

                        {/* Contenedor para tag y botón */}
                        <div className="flex items-center mt-1 gap-2">
                          {/* Tag */}
                          {item.tipo === "grupo" && (
                            <span className="text-xs px-2 py-1 rounded-full bg-gray-200 text-gray-600 capitalize">
                              {item.tipo}
                            </span>
                          )}
                          {item.tipo.toLowerCase() === "grupo" &&
                            !values[`grupo_${item.id}`] && (
                              <button
                                onClick={() =>
                                  eliminarGrupoLaboratorio(item.id)
                                }
                                className="w-8 h-8 bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 flex items-center justify-center text-xl"
                              >
                                <RiDeleteBinLine />
                              </button>
                            )}

                          {/* Botón de eliminar */}
                        </div>
                      </div>

                      {/* Input - solo muestra cuando está activo */}
                      {item.tipo === "laboratorio" &&
                        values[`lab_${item.id}`] && (
                          <div className="w-1/2">
                            <Input
                              color={true}
                              register={register(
                                `resultados.${`lab_${item.id}`}`
                              )}
                              disabled={false}
                              className="w-full border border-black"
                            />
                          </div>
                        )}
                    </div>
                  </div>
                ))
            : listaFinal.map((item, index) => (
                <div key={index} className="flex items-start py-2">
                  {" "}
                  {/* Cambio 1: items-start y py-2 */}
                  <div className="flex-shrink-0 h-10 flex items-center">
                    {" "}
                    {/* Cambio 2: Contenedor para el switch */}
                    <Switch
                      checked={
                        !!values[
                          item.tipo === "grupo"
                            ? `grupo_${item.id}`
                            : `lab_${item.id}`
                        ]
                      }
                      onChange={handleSwitchChange(item)}
                      className={`${
                        values[
                          item.tipo === "grupo"
                            ? `grupo_${item.id}`
                            : `lab_${item.id}`
                        ]
                          ? "bg-subMain"
                          : "bg-border"
                      } 
                    relative inline-flex p-[2px] w-12 cursor-pointer rounded-full transitions flex-shrink-0`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${
                          values[
                            item.tipo === "grupo"
                              ? `grupo_${item.id}`
                              : `lab_${item.id}`
                          ]
                            ? "translate-x-5"
                            : "translate-x-0"
                        } 
                      pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg transitions`}
                      />
                    </Switch>
                  </div>
                  {/* Contenedor principal del contenido */}
                  <div
                    className={`flex ${
                      item.tipo === "laboratorio" && values[item.nombre]
                        ? "w-full"
                        : ""
                    } ml-3`}
                  >
                    {/* Label y tag - ancho condicional */}
                    <div
                      className={`${
                        item.tipo === "laboratorio" && values[item.nombre]
                          ? "w-1/2 pr-2"
                          : "w-full"
                      } flex flex-col`}
                    >
                      {/* Label - ocupa el espacio necesario */}
                      <span className="capitalize text-sm">{item.nombre}</span>

                      {/* Contenedor para tag y botón */}
                      <div className="flex items-center mt-1 gap-2">
                        {/* Tag */}
                        {item.tipo === "grupo" && (
                          <span className="text-xs px-2 py-1 rounded-full bg-gray-200 text-gray-600 capitalize">
                            {item.tipo}
                          </span>
                        )}
                        {item.tipo.toLowerCase() === "grupo" &&
                          !values[`grupo_${item.id}`] && (
                            <button
                              onClick={() => eliminarGrupoLaboratorio(item.id)}
                              className="w-8 h-8 bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 flex items-center justify-center text-xl"
                            >
                              <RiDeleteBinLine />
                            </button>
                          )}

                        {/* Botón de eliminar */}
                      </div>
                    </div>

                    {/* Input - solo muestra cuando está activo */}
                    {item.tipo === "laboratorio" &&
                      values[`lab_${item.id}`] && (
                        <div className="w-1/2">
                          <Input
                            color={true}
                            register={register(
                              `resultados.${`lab_${item.id}`}`
                            )}
                            disabled={false}
                            className="w-full border border-black"
                          />
                        </div>
                      )}
                  </div>
                </div>
              ))}
        </div>

        <div className="overflow-y-scroll md:pl-2 pt-2 md:pt-0 mt-2">
          <h3 className="text-sm font-semibold mb-2 text-gray-600">
            Laboratorios seleccionados
          </h3>
          {listaFinal
            .filter((item) => {
              const key = `lab_${item.id}`;
              return values[key];
            })
            .map(
              (item, index) =>
                item.tipo === "laboratorio" && (
                  <div
                    key={index}
                    className="mb-3 p-3 border rounded-lg bg-gray-50 shadow-sm"
                  >
                    <p className="text-base font-medium text-gray-800 capitalize">
                      {item.nombre}
                    </p>
                    {/* <p className="text-xs text-gray-500 italic">
                    Tipo: {item.tipo} {item.tipo === 'laboratorio' && `| ID Agrupación: ${item.grupoNombre}`}
                  </p> */}
                  </div>
                )
            )}
        </div>
      </div>

      {/*archivos?.length > 0 && (
        <div>
          <h2>Archivos adjuntos</h2>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Nombre
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Archivo
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {archivos.split(",").map((file, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {file.split("/")?.at(-1)}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <a
                      href={file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-subMain"
                    >
                      <span className="mr-2 inline-block">
                        <FileIcon extension={file.split(".").pop()} />
                      </span>
                      Descargar
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
      */}
      {/* <div className="flex gap-3 flex-col w-full col-span-6 my-2">
        <p className="text-sm">Archivos Adjuntos</p>
        <div className="grid xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 w-full">
          {files.length > 0 &&
            files.map((file, i) => (
              <div className="relative w-full">
                <img
                  src={file?.preview}
                  alt={file.name}
                  className="w-full  md:h-40 rounded-lg object-cover mt-5 p-1"
                  key={i}
                />
                <button
                  onClick={() => deleteFile(i)}
                  className="bg-white rounded-full w-8 h-8 flex-colo absolute -top-1 -right-1"
                >
                  <FaTimes className="text-red-500" />
                </button>
              </div>
            ))}
        </div>

        <MultipleUploader
          setFile={setFiles}
          file={files}
          title="Arrastre sus archivos aqui"
          placeholder="Solo se aceptan archivos tipo imagen y documento"
        />
      </div> */}
      </fieldset>
      <Button label={saveUncertain ? "Confirmar guardado" : "Guardar"} loading={cargando}
        disabled={!online || (!saveUncertain && loadState !== "ready")}
        onClick={handleSubmit(onSubmit)} />
    </>
  );
};

export default Laboratorio;
